import {
    Box,
    Grid,
    Table,
    CircularProgress,
    TableCell,
    TableHead,
    TableRow,
    Typography,
    TableContainer,
    Paper,
    TableBody,
    Chip,
    Button,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText,
    Drawer,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle, InputAdornment, TextField, Stack
} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import UserService from "../services/UserService";
import { formatDate } from "../services/utils";
import DossierService from "../services/DossierService";
import LinearWithValueLabel from "./LinearProgressWithLabel";
import DehazeIcon from '@mui/icons-material/Dehaze';
import AppsIcon from '@mui/icons-material/Apps';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArchiveIcon from '@mui/icons-material/Archive';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import SectionComponent from "./sections/SectionComponent";
import DocIcon from '../assets/icons/docIcon.png';
import DocComponent from "./DocComponent";
import {Pagination} from "antd";
import PaginatedList from "./PaginatedList";

const PrincipalComponent = () => {
    const [dossiers, setDossiers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [sectionStats, setSectionStats] = useState({});

    // Pour la pagination

    const [gridFormat, setGridFormat] = useState(true);

    const gridToLine = () => {
        setGridFormat(!gridFormat);
    }

    const date = useRef(null);
    const searchKeyword = useRef(null);

    // ======== Pour le menu des actions ==========
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedDossier, setSelectedDossier] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event, dossier) => {
        setAnchorEl(event.currentTarget);
        setSelectedDossier(dossier);
    };

    const handleClickSearch = () => {

    }

    const handleClose = () => {
        setAnchorEl(null);
        setSelectedDossier(null);
    };



    // ======== Pour le Drawer ==========
    const [drawerOpen, setDrawerOpen] = useState(false);
    const [drawerData, setDrawerData] = useState(null);

    const handleConsulter = () => {
        setDrawerData(selectedDossier);
        setDrawerOpen(true);
        handleClose();
    };

    const handleDrawerClose = () => {
        setDrawerOpen(false);
        setDrawerData(null);
    };

    // ======== Pour le Dialog Alert ==========
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dossierToArchive, setDossierToArchive] = useState(null);

    const handleArchiver = () => {
        setDossierToArchive(selectedDossier);
        setDialogOpen(true);
        handleClose();
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
        setDossierToArchive(null);
    };

    const confirmArchive = async () => {
        try {
            // Ici vous pouvez ajouter l'appel API pour archiver le dossier
            console.log("Archivage du dossier:", dossierToArchive.id);
            // await secDossier.archiveDossier(dossierToArchive.id);

            // Mettre à jour localement le dossier comme archivé
            setDossiers(prevDossiers =>
                prevDossiers.map(dossier =>
                    dossier.id === dossierToArchive.id
                        ? { ...dossier, isArchived: true }
                        : dossier
                )
            );

            handleDialogClose();
        } catch (error) {
            console.error("Erreur lors de l'archivage:", error);
        }
    };

    const secDossier = new DossierService();

    useEffect(() => {
        const fetchUserDossiers = async () => {
            try {
                const userService = new UserService();
                const response = await userService.userDossier();
                setDossiers(response);
                setTotalCount(response.length);

                // Calculer les statistiques des sections pour chaque dossier
                const stats = {};
                await Promise.all(
                    response.map(async (dossier) => {
                        const totalSections = await nbreSect(dossier.id);
                        const completedSections = await nbreSectComp(dossier.id);
                        stats[dossier.id] = {
                            total: totalSections,
                            completed: completedSections
                        };
                    })
                );
                setSectionStats(stats);
            } catch (error) {
                console.error("Error fetching user data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchUserDossiers();
    }, []);

    console.log("Les infos du dossier", dossiers);

    const nbreSect = async (code) => {
        try {
            const response = await secDossier.allDossierSectionsNumber(code);
            return response;
        } catch (error) {
            console.error("Error fetching total sections:", error);
            return 0;
        }
    };

    const nbreSectComp = async (code) => {
        try {
            const response = await secDossier.numberDossierSectionsComplete(code);
            return response;
        } catch (error) {
            console.error("Error fetching completed sections:", error);
            return 0;
        }
    };

    function handleFilter (filterBy, value) {
        switch (filterBy) {
            case "searchKeyword":
                searchKeyword.current = value;
                console.log("searchKeyword", searchKeyword.current);
                break;
            case "date":
                date.current = value;
                console.log("date", date.current);
                break;
            default:
                break;
        }
    }

    return (
        <Box p={2} sx={{ backgroundColor: '#F4F6F8'}}>
            <Box sx={{ backgroundColor: '#FFFFFF'}} p={2}>
                <Typography variant="h5">Historique des dossiers</Typography>
            </Box>




            <Box sx={{ marginTop: '40px', minHeight: '300px', backgroundColor: '#FFFFFF', borderRadius: '8px', border: "1px #D7D7D7 solid" }} p={1}>

                <Box mb={5} p={4} sx={{ borderBottom: '1px #D7D7D7 solid' }}>
                    <Grid container spacing={2}>
                        {/* 🔍 Recherche */}
                        {/*<Grid item xs={12} sm={5}>*/}
                        {/*    <Box display="flex" flexDirection="column" justifyContent="flex-end" height="100%">*/}
                        {/*        <TextField*/}
                        {/*            placeholder="Rechercher par code du document"*/}
                        {/*            variant="outlined"*/}
                        {/*            fullWidth*/}
                        {/*            InputProps={{*/}
                        {/*                startAdornment: (*/}
                        {/*                    <InputAdornment position="start">*/}
                        {/*                        <SearchIcon />*/}
                        {/*                    </InputAdornment>*/}
                        {/*                ),*/}
                        {/*            }}*/}
                        {/*            onChange={(e) => handleFilter("searchKeyword", e.target.value)}*/}
                        {/*        />*/}
                        {/*    </Box>*/}
                        {/*</Grid>*/}

                        {/* 📅 Date de soumission */}
                        {/*<Grid item xs={12} sm={2}>*/}
                        {/*    <Box display="flex" flexDirection="column" justifyContent="flex-end" height="100%">*/}
                        {/*        <TextField*/}
                        {/*            label="Date de soumission"*/}
                        {/*            type="date"*/}
                        {/*            variant="outlined"*/}
                        {/*            fullWidth*/}
                        {/*            InputLabelProps={{*/}
                        {/*                shrink: true,*/}
                        {/*            }}*/}
                        {/*            onChange={(e) => handleFilter("date", e.target.value)}*/}
                        {/*        />*/}
                        {/*    </Box>*/}
                        {/*</Grid>*/}

                        {/* 🔘 Bouton Rechercher */}
                        {/*<Grid item xs={12} sm={1} display="flex" justifyContent="center" alignItems="center" >*/}
                        {/*    <Button variant="contained" color="success" onClick={handleClickSearch} fullWidth sx={{ height: '100%' }}>*/}
                        {/*        Rechercher*/}
                        {/*    </Button>*/}
                        {/*</Grid>*/}

                        <Grid item xs={12} sm={12} display="flex" justifyContent="flex-end" alignItems="center">
                            <Button onClick={gridToLine}>
                                {
                                    gridFormat ? <AppsIcon color="success" /> : <DehazeIcon color="success" />
                                }

                            </Button>
                        </Grid>
                    </Grid>
                </Box>

                {loading ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '300px' }}>
                        <CircularProgress color="success"/>
                    </Box>
                ) : (
                    <Box>

                        {
                            gridFormat ? (
                                <Box p={3}>
                                    <Grid container spacing={2}>
                                        {
                                            dossiers?.length > 0 ? dossiers?.map((dossier) => (
                                                <DocComponent
                                                    key={dossier.id}
                                                    dossier={dossier}
                                                    aria-controls={open ? 'basic-menu' : undefined}
                                                    aria-haspopup="true"
                                                    aria-expanded={open ? 'true' : undefined}
                                                    onClick={(event) => handleClick(event, dossier)}
                                                />
                                            )) :  (
                                                <TableRow>
                                                    <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                                                        Aucun dossier trouvé
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </Grid>
                                </Box>
                            ) : (
                                <Box p={3}>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Code</TableCell>
                                                    <TableCell>Créé le</TableCell>
                                                    <TableCell>Sections complétées</TableCell>
                                                    <TableCell>Pourcentage</TableCell>
                                                    <TableCell>Soumis</TableCell>
                                                    <TableCell>Archivé</TableCell>
                                                    <TableCell>Actions</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {dossiers?.length > 0 ? dossiers?.map((dossier) => (
                                                    <TableRow key={dossier.id}>
                                                        <TableCell>DOS-{dossier.id}</TableCell>
                                                        <TableCell>{formatDate(dossier.dateCreated)}</TableCell>
                                                        <TableCell>
                                                            {sectionStats[dossier.id]
                                                                ? `${sectionStats[dossier.id].completed}/${sectionStats[dossier.id].total}`
                                                                : 'N/A'
                                                            }
                                                        </TableCell>
                                                        <TableCell>
                                                            {sectionStats[dossier.id] ? (
                                                                <LinearWithValueLabel
                                                                    val={sectionStats[dossier.id].completed}
                                                                    total={sectionStats[dossier.id].total}
                                                                />
                                                            ) : (
                                                                <LinearWithValueLabel val={0} total={4} />
                                                            )}
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                label={dossier.soumis ? "Oui" : "Non"}
                                                                sx={{
                                                                    width: "60px",
                                                                    borderRadius: "5px",
                                                                    border: dossier.soumis ? "1px solid #0ac62a" : "1px solid #f8290d",
                                                                    backgroundColor: dossier.soumis ? "rgba(10, 198, 42, 0.1)" : "rgba(248, 41, 13, 0.1)",
                                                                    color: dossier.soumis ? "#0ac62a" : "#f8290d"
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                label={dossier.isArchived ? "Oui" : "Non"}
                                                                sx={{
                                                                    width: "60px",
                                                                    borderRadius: "5px",
                                                                    border: dossier.isArchived ? "1px solid #0ac62a" : "1px solid #f8290d",
                                                                    backgroundColor: dossier.isArchived ? "rgba(10, 198, 42, 0.1)" : "rgba(248, 41, 13, 0.1)",
                                                                    color: dossier.isArchived ? "#0ac62a" : "#f8290d"
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell>
                                                            <Button
                                                                aria-controls={open ? 'basic-menu' : undefined}
                                                                aria-haspopup="true"
                                                                aria-expanded={open ? 'true' : undefined}
                                                                onClick={(event) => handleClick(event, dossier)}
                                                            >
                                                                <MoreVertIcon />
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                )) : (
                                                    <TableRow>
                                                        <TableCell colSpan={7} sx={{ textAlign: 'center' }}>
                                                            Aucun dossier trouvé
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            )
                        }

                    </Box>
                )}
            </Box>

            {/* Menu contextuel */}
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={handleConsulter}>
                    <ListItemIcon>
                        <VisibilityIcon />
                    </ListItemIcon>
                    <ListItemText primary="Consulter" />
                </MenuItem>

                <MenuItem onClick={handleArchiver}>
                    <ListItemIcon>
                        <ArchiveIcon />
                    </ListItemIcon>
                    <ListItemText primary="Archiver" />
                </MenuItem>
            </Menu>

            {/* Drawer pour consulter */}
            <Drawer
                anchor="right"
                open={drawerOpen}
                onClose={handleDrawerClose}
                PaperProps={{
                    sx: { width: '60vw' }
                }}
            >
                <Box sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
                        <Typography variant="h6">
                            Détails du dossier
                        </Typography>
                        <Button
                            onClick={handleDrawerClose}
                            size="small"
                            sx={{ minWidth: 'auto', p: 1 }}
                        >
                            <CloseIcon />
                        </Button>
                    </Box>

                    {drawerData && (
                        <Box sx={{ flex: 1 }}>
                            <Box sx={{ mb: 3, p: 2, bgcolor: 'grey.50', borderRadius: 1 }}>
                                <Grid container>
                                    <Grid item xs={6} sm={3}>
                                        <Typography variant="h6" color="primary" gutterBottom>
                                            DOS-{drawerData.id}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Code du dossier
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Typography variant="body1" sx={{ mb: 2 }}>
                                            {formatDate(drawerData.dateCreated)}
                                        </Typography>
                                        <Typography variant="subtitle2" color="text.secondary">
                                            Date de création
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={6} sm={3}>
                                        <Grid container>
                                            <Grid item xs={6} sm={6}>
                                                <Box>
                                                    <Typography variant="subtitle2" color="text.secondary">
                                                        Soumis
                                                    </Typography>
                                                    <Chip
                                                        label={drawerData.soumis ? "Oui" : "Non"}
                                                        size="small"
                                                        sx={{
                                                            mt: 0.5,
                                                            borderRadius: "5px",
                                                            border: drawerData.soumis ? "1px solid #0ac62a" : "1px solid #f8290d",
                                                            backgroundColor: drawerData.soumis ? "rgba(10, 198, 42, 0.1)" : "rgba(248, 41, 13, 0.1)",
                                                            color: drawerData.soumis ? "#0ac62a" : "#f8290d"
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                            <Grid item xs={6} sm={6}>
                                                <Box>
                                                    <Typography variant="subtitle2" color="text.secondary">
                                                        Archivé
                                                    </Typography>
                                                    <Chip
                                                        label={drawerData.isArchived ? "Oui" : "Non"}
                                                        size="small"
                                                        sx={{
                                                            mt: 0.5,
                                                            borderRadius: "5px",
                                                            border: drawerData.isArchived ? "1px solid #0ac62a" : "1px solid #f8290d",
                                                            backgroundColor: drawerData.isArchived ? "rgba(10, 198, 42, 0.1)" : "rgba(248, 41, 13, 0.1)",
                                                            color: drawerData.isArchived ? "#0ac62a" : "#f8290d"
                                                        }}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={6} sm={3}></Grid>
                                    <Grid item xs={12} sm={12}>
                                        <Typography variant="subtitle2" color="text.secondary">
                                            Progression
                                        </Typography>
                                        <Box sx={{ mt: 1 }}>
                                            {sectionStats[drawerData.id] ? (
                                                <LinearWithValueLabel
                                                    val={sectionStats[drawerData.id].completed}
                                                    total={sectionStats[drawerData.id].total}
                                                />
                                            ) : (
                                                <LinearWithValueLabel val={0} total={4} />
                                            )}
                                        </Box>
                                        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                                            {sectionStats[drawerData.id]
                                                ? `${sectionStats[drawerData.id].completed}/${sectionStats[drawerData.id].total} sections complétées`
                                                : 'N/A'
                                            }
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Box>
                            <Box sx={{ marginTop: '10px' }}>
                                <Typography variant="h6" gutterBottom>
                                    Sections du dossier
                                </Typography>
                                <SectionComponent dossier={drawerData.id} />
                            </Box>
                        </Box>
                    )}
                </Box>
            </Drawer>

            {/* Dialog de confirmation pour archiver */}
            <Dialog
                open={dialogOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle id="alert-dialog-title">
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <ArchiveIcon sx={{ mr: 1, color: 'warning.main' }} />
                        Confirmer l'archivage
                    </Box>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Êtes-vous sûr de vouloir archiver le dossier{' '}
                        <strong>{dossierToArchive && `DOS-${dossierToArchive.id}`}</strong> ?
                        <br /><br />
                        Cette action marquera le dossier comme archivé dans le système.
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ p: 2, gap: 1 }}>
                    <Button onClick={handleDialogClose} variant="outlined">
                        Annuler
                    </Button>
                    <Button
                        onClick={confirmArchive}
                        variant="contained"
                        color="success"
                        startIcon={<ArchiveIcon />}
                    >
                        Archiver
                    </Button>
                </DialogActions>
            </Dialog>

            <Box mt={5}>
                <Grid container spacing={2} sx={{ justifyContent: 'flex-end' }}>

                    <PaginatedList page={page} setPage={setPage} nbrItems={totalCount} itemsPerPage={gridFormat ? 20 : 10}/>

                </Grid>
            </Box>
        </Box>
    );
};

export default PrincipalComponent;